import React from "react";
import Main from "../../components/layout/Main";
import { BackButton } from "../../components/layout/app/AppHeader";
import "../../assets/styles/app-preferences.css";

// The app's Subscription screen (app/screens/HomeSettings/Subscription.js).
const PLANS = [
  { months: 12, cost: "900/INR", color: "#7448e0" },
  { months: 24, cost: "Coming Soon..", color: "#7448e0" },
  { months: 36, cost: "Coming Soon..", color: "rgba(255, 204, 59, 1)" },
  { months: 49, cost: "Coming Soon..", color: "#FF416C" },
];

// "12 months", "2 years", ... as the app words them.
const duration = (months) => {
  if (months > 12) {
    const years = Math.floor(months / 12);
    return `${years} ${years > 1 ? "years" : "year"}`;
  }
  return `${months} ${months > 1 ? "months" : "month"}`;
};

function Subscription() {
  return (
    <Main header="none" bleed hideTabBar>
      <div className="hx-pref-sub">
        <div className="hx-pref-sub-hero">
          <BackButton className="hx-pref-sub-back" />
          <h1>Free Trial</h1>
          <p>(1 year)</p>
        </div>
        <ul className="hx-pref-plans">
          {PLANS.map((plan) => (
            <li key={plan.months} className="hx-pref-plan" style={{ "--hx-plan": plan.color }}>
              <span className="hx-pref-plan-length">{duration(plan.months)}</span>
              <span className="hx-pref-plan-cost">{plan.cost}</span>
            </li>
          ))}
        </ul>
      </div>
    </Main>
  );
}

export default Subscription;
